import Blue from "~/core";

new Blue ({
	name: 'Feature Modal',
	selector: '.feature__modal, .testimonial__modal',
	setup(modal) {
		const feature = modal.closest('.feature, .testimonial');
		const trigger = feature.querySelector('.feature__image, .testimonial__img');
		const backdrop = modal.querySelector('.feature__modal-backdrop, .testimonial__modal-backdrop');
		const closeBtn = modal.querySelector('.feature__modal-close, .testimonial__modal-close');
		const videoElement = modal.querySelector('.feature__video, .testimonial__video');
		const activeClass = feature.classList.contains('feature') ? "feature__modal--active" : "testimonial__modal--active";

		const closeModal = () => {
			this.$scrollLock.unlock(modal);
			modal.classList.remove(activeClass);
			if (videoElement.nodeName == 'IFRAME') videoElement.setAttribute('src', videoElement.getAttribute('src'));
			else if (videoElement.nodeName == 'VIDEO') videoElement.pause();
			trigger.focus();
		}
		this.$addEvents(trigger, "click.prevent enter.prevent", () => {
			this.$scrollLock.lock(modal);
			modal.classList.add(activeClass);
			backdrop.focus();
		});
		this.$addEvents(closeBtn, "click.prevent enter.prevent", closeModal);
		this.$addEvents(backdrop, "click.prevent enter.prevent", closeModal);
		this.$addEvents(modal, 'focusout', () => {
			if (!modal.matches(':focus-within')) {
				closeBtn.focus();
			}
		});
		this.$addEvents(modal, "escape", closeModal);
	}
});